import crypto from 'crypto'

class aes  {
    constructor () {
        this.password = this.convertCryptKey('teraslapassword')
    } 
    convertCryptKey(strKey) {
        const newKey = new Buffer([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
        strKey = new Buffer(strKey)
        for (let i = 0; i < strKey.length; i++) newKey[i % 16] ^= strKey[i]
        return newKey
    }
    encode(value){
        if (typeof value !== 'string') {
            value = JSON.stringify(value)
        }

        const c = crypto.createCipheriv('aes-128-ecb', this.password, '')
        let ret = ''
        ret += c.update(value, 'utf8', 'hex')
        ret += c.final('hex')
        return ret.toUpperCase()
    }
    decode(value){
        let ret = ''
        try{
            const d = crypto.createDecipheriv('aes-128-ecb', this.password, '')
            console.log("update")
            ret += d.update(value, 'hex', 'utf8')
            console.log("final")
            ret += d.final('utf8')
          }catch(e){
            ret = value
        }
        return ret
    }   

}

export default new aes
